import React from 'react'
import { useSelector } from 'react-redux'
import { Box, IconButton } from '@mui/material'
import { withStyles } from '@mui/styles'

import DeleteIcon from '@mui/icons-material/Delete'
import DoneIcon from '@mui/icons-material/Done'
import { tableActionsStyles } from './table-actions.style'
import { useGuildsContext } from '../../contexts/guilds.context'
import { useGuildDialogs } from '../../hooks/guilds-dialogs.hook'

export const TableActions = withStyles(tableActionsStyles)((props) => {
  const companyId = props.row.original['id']
  const { warnGuildEnterpriseDeletion } = useGuildDialogs()

  const { acceptCompany, deleteCompany } = useGuildsContext()
  const global = useSelector((state) => state.global)

  const handleDelete = () => {
    deleteCompany(global.gremio_id, companyId)
  }

  const handleDeleteRequest = () => {
    warnGuildEnterpriseDeletion(handleDelete)
  }

  const handlePut = () => {
    acceptCompany(global.gremio_id, companyId)
  }

  const guildsButtons = {
    delete: {
      onClick: handleDeleteRequest,
      icon: <DeleteIcon />,
    },
    accept: {
      onClick: handlePut,
      icon: <DoneIcon />,
    },
  }

  // NEVO-439 - Limitar ACVC post portal único: la Gestión de Asociados queda en modo
  // consulta para el perfil de gremios, sin poder aceptar/eliminar agremiados.
  const availableActions = []
  return (
    <Box className={props.classes.actionRow} p={0}>
      {availableActions.map((action) => {
        return (
          <IconButton
            className={props.classes.actionButton}
            key={action}
            size="small"
            onClick={guildsButtons[action].onClick}
          >
            {guildsButtons[action].icon}
          </IconButton>
        )
      })}
    </Box>
  )
})
